module.exports = __webpack_public_path__ + "img/powered-by-strava.3bdf17f5.svg";